import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isString from 'lodash.isstring';

import { API_URL } from '../../../../config/constants';
import { long } from '../../common/formatting/date';
import ImageModal from '../components/ImageModal';

const TimelinePanel = ({
	position,
	comment,
	journalEntry,
	image_name,
	id,
	update_dttm
}) => {
	// TODO clicking on image.clickable should open a modal with a full size image
	// TODO image in modal should support zooming, panning, etc.
	const [isImageModalOpen, setImageModalOpen] = useState(false);
	const imageSrc = `${API_URL}/healthJournalTransactionImages/${id}/download/${image_name}`;
	return (
		<React.Fragment>
			<ImageModal
				isOpen={isImageModalOpen}
				onClose={() => setImageModalOpen(false)}
				imageSrc={imageSrc}
			/>
			<div className="timeline-panel">
				<div className={cn('popover', `${position}`)}>
					<h4 className="popover-title">
						{journalEntry && isString(journalEntry.optionLabel) && (
							journalEntry.optionLabel
						)}
					</h4>
					<div className="arrow" />
					<div className="popover-content clearfix">
						{isString(image_name) && image_name.length > 0 && (
							<div className="pull-right">
								<img
									className="thumb48 clickable"
									src={imageSrc}
									onClick={() => setImageModalOpen(true)}
								/>
							</div>
						)}
						<p>{comment}
							<br />
							<small>
								<small>{long(update_dttm)}</small>
							</small>
						</p>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

TimelinePanel.propTypes = {
	position: PropTypes.string,
	comment: PropTypes.string,
	journalEntry: PropTypes.object,
	image_name: PropTypes.string,
	id: PropTypes.number,
	update_dttm: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default TimelinePanel;
